import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/shared/lib/supabase'
import type { KanbanColumn } from '@/shared/types'

export interface FeatureHistoryEntry {
  id: string
  feature_id: string
  from_column: KanbanColumn | null
  to_column: KanbanColumn
  changed_at: string
  changed_by: string | null
}

async function fetchFeatureHistory(featureId: string | undefined): Promise<FeatureHistoryEntry[]> {
  if (!featureId) return []

  const { data, error } = await supabase
    .from('feature_status_history')
    .select('*')
    .eq('feature_id', featureId)
    .order('changed_at', { ascending: true })

  if (error) {
    throw new Error(error.message)
  }

  return data || []
}

export function useFeatureHistory(featureId: string | undefined) {
  return useQuery({
    queryKey: ['featureHistory', featureId],
    queryFn: () => fetchFeatureHistory(featureId),
    enabled: !!featureId,
  })
}
